import dayjs from '~/timeInit';

import {
  CREATE_TYPE_PEOPLE_AND_CULTURE,
  CREATE_TYPE_REACTIVATED_CREDIT,
  CREDIT_TYPES_WITHOUT_TICKET_ID,
  CREDIT_TYPE_LEBT_ISSUED,
  ONE_MONTH_EXPIRY,
  TWELVE_MONTH_EXPIRY,
} from '~/consts/credits';

import { SYDNEY_TIMEZONE } from '~/services/TimeService';

/**
 * Default expiry for a newly granted credit: end of day in Sydney, 12 months out unless the credit type says otherwise.
 * Sydney is used instead of the browser's timezone so the same grant expires at the same instant wherever the admin is.
 */
export function getDefaultCreditExpiry(creditType?: string): string {
  let expiryMonths = TWELVE_MONTH_EXPIRY;

  switch (creditType) {
    case CREATE_TYPE_REACTIVATED_CREDIT:
    case CREATE_TYPE_PEOPLE_AND_CULTURE:
      expiryMonths = ONE_MONTH_EXPIRY;
      break;
    case CREDIT_TYPE_LEBT_ISSUED:
      expiryMonths = 3 * TWELVE_MONTH_EXPIRY;
      break;
  }

  return dayjs().tz(SYDNEY_TIMEZONE).add(expiryMonths, 'month').endOf('day').format();
}

/** Most credit types must reference a support ticket; a few (bulk, agent hub, test) do not. */
export function isTicketIdRequiredForCreditType(creditType?: string): boolean {
  return Boolean(creditType) && !CREDIT_TYPES_WITHOUT_TICKET_ID.includes(creditType);
}
